import styles from './address-field.module.css';
import {Address1Field} from './address1-field';
import {Address2Field} from './address2-field';
import {ZipField} from './zip-field';
import {useGetZipCodeToAddressQuery} from '@/hooks/api/use-get-zip-code-to-address-query';
import {useCompanyRegistrationFormContext} from '@/features/company-registration/form';

export function AddressField() {
  const {
    getValues,
    setValue,
    trigger,
    formState: {isSubmitted},
  } = useCompanyRegistrationFormContext();
  const {fetchZipCodeToAddress} = useGetZipCodeToAddressQuery();

  const onAutoFillAddress = async () => {
    const result = await trigger('billingInfo.zip', {
      shouldFocus: true,
    });
    if (!result) {
      return;
    }

    const address = await fetchZipCodeToAddress({
      zipCode: getValues('billingInfo.zip'),
    });

    setValue(
      'billingInfo.address',
      `${address.data[0].prefecture}${address.data[0].city}${address.data[0].town}`,
    );
    if (isSubmitted) {
      void trigger('billingInfo.address');
    }
  };

  return (
    <div className={styles.container}>
      <ZipField onAutoFillAddress={onAutoFillAddress} />
      <Address1Field />
      <Address2Field />
    </div>
  );
}
